(function cascadiaSampleStudio(){
  const CFG = window.cascadiaConfig || {};
  const TIERS = (CFG.rewardTiers || [])
    .filter(t => t.type !== 'free_shipping')
    .sort((a,b) => a.threshold - b.threshold);
  const SCENTS = (CFG.sampleScents || []).filter(s => s.available > 0);
  const $body = () => document.querySelector('#CartPageForm') ||
    document.querySelector('.drawer__inner, .cart-drawer__content, [data-cart-drawer] .drawer__cart');

  async function cartAdd(variantId, props){
    return window.cascadiaState.addToCart(variantId, 1, props);
  }

  function dispatchUpdate(){
    if(document.querySelector('#CartPageForm')){
      window.location.reload();
    }
  }

  function findRewardLine(cart, type){
    return cart.items.find(i => i.properties && i.properties._reward === type);
  }

  async function swapReward(cart, type, variantId, extraProps){
    const existing = findRewardLine(cart, type);
    if(existing){
      await window.cascadiaState.removeFromCart(existing.key);
    }
    const props = Object.assign({ _reward: type }, extraProps);
    if(type === 'soap_sample') props._sample = 'soap';
    await window.cascadiaState.addToCart(variantId, 1, props);
  }

  async function render(){
    const body = $body(); if(!body) return;
    let cart; try { cart = await window.cascadiaState.getState(); } catch(e){ return; }
    const total = cart.total;

    const existing = body.querySelector('#cascadia-studio');
    if(existing) existing.remove();

    const studio = document.createElement('div');
    studio.id = 'cascadia-studio';
    const productsContainer = body.querySelector('[data-products]');
    if(productsContainer){
      productsContainer.parentNode.insertBefore(studio, productsContainer.nextSibling);
    } else {
      const anchor = body.querySelector('#cascadia-trust') || body.lastElementChild;
      anchor ? anchor.parentNode.insertBefore(studio, anchor) : body.appendChild(studio);
    }

    const unlockedCount = TIERS.filter(t => total >= t.threshold * 100).length;

    studio.innerHTML = `
      <div class="cas-studio-header">
        <div>
          <p class="cas-studio-title">${CFG.studioTitle || 'Your gifts'}</p>
        </div>
        <span class="cas-studio-badge">${unlockedCount} of ${TIERS.length} unlocked</span>
      </div>
      <div id="cas-studio-tiers"></div>`;

    const tiersEl = studio.querySelector('#cas-studio-tiers');

    TIERS.forEach((tier, idx) => {
      const unlocked = total >= tier.threshold * 100;
      const isNext = !unlocked && TIERS.slice(0, idx).every(t => total >= t.threshold * 100);
      // Fully-locked tiers beyond the immediate next one are already shown by
      // the ladder up top — skip the row here so this card only shows what's
      // actionable right now (unlocked pickers + the one you're working toward).
      if(!unlocked && !isNext) return;
      const remaining = ((tier.threshold * 100) - total) / 100;
      const prevThreshold = idx === 0 ? 0 : TIERS[idx-1].threshold * 100;
      const tierSpan = tier.threshold * 100 - prevThreshold;
      const tierProgress = Math.min(100, Math.max(0, ((total - prevThreshold) / tierSpan) * 100));

      const row = document.createElement('div');
      row.className = 'cas-tier-row' + (unlocked ? ' cas-unlocked' : '') + (isNext ? ' cas-next' : '');

      let headerHtml;
      if(unlocked){
        headerHtml = `
          <div class="cas-tier-head">
            <span class="cas-tier-name">${tier.label}</span>
            <span class="cas-tier-status cas-tier-status--unlocked">✓ unlocked</span>
          </div>`;
      } else if(isNext){
        headerHtml = `
          <div class="cas-tier-head">
            <span class="cas-tier-name cas-tier-name--muted">${tier.label}</span>
            <div class="cas-tier-next-meta">
              <div class="cas-tier-progress-bar">
                <div class="cas-tier-progress-fill" style="width:${tierProgress}%"></div>
              </div>
              <span class="cas-tier-almost">Just $${remaining.toFixed(2)} away</span>
            </div>
          </div>`;
      } else {
        headerHtml = `
          <div class="cas-tier-head">
            <span class="cas-tier-name cas-tier-name--faint">${tier.label}</span>
            <span class="cas-tier-status cas-tier-status--faint">$${remaining.toFixed(2)} away</span>
          </div>`;
      }

      row.innerHTML = `${headerHtml}<div class="cas-tier-body"></div>`;
      tiersEl.appendChild(row);

      if(!unlocked) return;
      const bodyEl = row.querySelector('.cas-tier-body');
      if(tier.type === 'soap_sample'){
        renderSoapTier(bodyEl, cart);
      } else {
        renderProductTier(bodyEl, cart, tier);
      }
    });
  }

  function renderSoapTier(container, cart){
    const sampleLine = cart.rewardLines['soap_sample'] || null;
    const selectedName = sampleLine?.properties?._scent || null;

    container.innerHTML = `
      <div class="cas-scent-pill-grid">
        ${SCENTS.map((s,i) => `
          <button class="cas-scent-pill ${selectedName===s.name?'sel':''}"
            role="radio" aria-checked="${selectedName===s.name}"
            tabindex="${(selectedName?selectedName===s.name:i===0)?0:-1}"
            data-i="${i}">
            <span class="cas-scent-pill-dot" style="background:${s.hex}"></span>
            <span class="cas-scent-pill-name">${s.name}</span>
          </button>`).join('')}
      </div>`;

    wireSoapPicker(container, cart);
  }

  function wireSoapPicker(container, cart){
    const pills = [...container.querySelectorAll('.cas-scent-pill')];
    let busy = false;

    pills.forEach(el => {
      const s = SCENTS[+el.dataset.i];
      el.addEventListener('click', async e => {
        e.preventDefault(); e.stopPropagation();
        if(busy) return;
        busy = true;
        pills.forEach(p=>{ p.classList.remove('sel'); p.setAttribute('aria-checked','false'); p.tabIndex=-1; });
        el.classList.add('sel'); el.setAttribute('aria-checked','true'); el.tabIndex=0;
        try {
          const freshCart = await window.cascadiaState.refresh();
          await swapReward(freshCart, 'soap_sample', s.variantId, { _scent: s.name });
          dispatchUpdate();
        } catch(err){ console.warn('[cascadia studio] soap add failed', err); }
        finally { busy = false; }
      });
      el.addEventListener('keydown', e => {
        const i = +el.dataset.i;
        if(['ArrowRight','ArrowDown'].includes(e.key)){ e.preventDefault(); pills[(i+1)%pills.length].focus(); }
        if(['ArrowLeft','ArrowUp'].includes(e.key)){ e.preventDefault(); pills[(i-1+pills.length)%pills.length].focus(); }
        if([' ','Enter'].includes(e.key)){ e.preventDefault(); el.click(); }
      });
    });
  }

  function renderProductTier(container, cart, tier){
    const rewardLine = cart.rewardLines[tier.type] || null;
    const selectedVariantId = rewardLine?.variant_id || null;
    const products = tier.rewardProducts || [];

    if(!products.length){
      container.innerHTML = `<p class="cas-selname cas-selname--dim">${CFG.studioComingSoon || 'Coming soon.'}</p>`;
      return;
    }

    // single product, no scents, multiple variants — show variant picker directly
    const singleNoScent = products.length === 1 && !products[0].hasScents && products[0].variants.length > 1;
    if(singleNoScent){
      const prod = products[0];
      let selectedLabel = '';
      if(rewardLine){
        const matchVar = prod.variants.find(v => v.id === selectedVariantId);
        if(matchVar) selectedLabel = `<b>${matchVar.title}</b> — added to your cart`;
      }

      container.innerHTML = `
        <div class="cas-variant-grid" style="display:flex;flex-wrap:wrap;gap:8px;padding:4px 0;"></div>`;

      const grid = container.querySelector('.cas-variant-grid');
      let busy = false;

      prod.variants.forEach(v => {
        const card = document.createElement('button');
        card.style.cssText = 'all:unset;cursor:pointer;display:flex;flex-direction:column;align-items:center;gap:4px;width:80px;padding:6px;border-radius:10px;border:0.5px solid #e8e5e0;background:#fff;text-align:center;box-sizing:border-box;';
        card.innerHTML = `
          <img src="${v.image || prod.image}" alt="${v.title}"
            style="width:60px;height:60px;object-fit:cover;border-radius:6px;display:block;" />
          <span style="font-family:'Jost',sans-serif;font-size:9.5px;color:#6b5c4a;line-height:1.3;">${v.title}</span>`;

        if(rewardLine && v.id === selectedVariantId){
          card.classList.add('sel');
          card.style.borderColor = '#03593A';
        }

        card.addEventListener('mouseenter', () => { if(!card.classList.contains('sel')) card.style.borderColor = '#3d2314'; });
        card.addEventListener('mouseleave', () => { if(!card.classList.contains('sel')) card.style.borderColor = '#e8e5e0'; });
        card.addEventListener('click', async e => {
  e.stopPropagation();
  e.preventDefault();
          if(busy) return;
          busy = true;
          grid.querySelectorAll('button').forEach(c => { c.classList.remove('sel'); c.style.borderColor = '#e8e5e0'; });
          card.classList.add('sel');
          card.style.borderColor = '#03593A';
          try {
            const freshCart = await window.cascadiaState.refresh();
            await swapReward(freshCart, tier.type, v.id, {});
            dispatchUpdate();
          } catch(err){ console.warn('[cascadia studio] variant add failed', err); }
          finally { busy = false; }
        });
        grid.appendChild(card);
      });
      return;
    }

    let selectedLabel = CFG.studioChooseReward || 'Choose a reward — added free to your cart';
    let selectedProdHandle = null;
    if(rewardLine){
      const matchProd = products.find(p => p.variants.some(v => v.id === selectedVariantId));
      if(matchProd){
        selectedProdHandle = matchProd.handle;
        const matchVar = matchProd.variants.find(v => v.id === selectedVariantId);
        selectedLabel = matchProd.hasScents && matchVar
          ? `<b>${matchProd.title} · ${matchVar.scent}</b> — added to your cart`
          : `<b>${matchProd.title}</b> — added to your cart`;
      }
    }

    container.innerHTML = `
      <div class="cas-prod-row">
        ${products.map(p => {
          const isSelected = p.handle === selectedProdHandle;
          const img = p.image
            ? `<img src="${p.image}" alt="" class="cas-prod-img">`
            : `<div class="cas-prod-img cas-prod-img-empty"></div>`;
          return `
            <div class="cas-prod-card ${isSelected?'sel':''}" data-handle="${p.handle}" data-has-scents="${p.hasScents}">
              ${img}
              <p class="cas-prod-name">${p.title}</p>
            </div>`;
        }).join('')}
      </div>
      <div class="cas-scent-strip" style="display:none">
        <p class="cas-scent-strip-label"></p>
        <div class="cas-dot-grid"></div>
      </div>`;

    wireProductPicker(container, cart, tier, products);
  }

  function wireProductPicker(container, cart, tier, products){
    const row = container.querySelector('.cas-prod-row');
    const strip = container.querySelector('.cas-scent-strip');
    let busy = false;

    row.querySelectorAll('.cas-prod-card').forEach((card, idx) => {
      const prod = products[idx];
      card.addEventListener('click', async () => {
        if(busy) return;
        row.querySelectorAll('.cas-prod-card').forEach(c => c.classList.remove('sel'));
        card.classList.add('sel');
        strip.style.display = 'none';
        strip.querySelector('.cas-dot-grid').innerHTML = '';

        if(prod.hasScents && prod.variants.length > 1){
          strip.querySelector('.cas-scent-strip-label').textContent = `${CFG.studioScentStripLabel || 'Choose a scent for'} ${prod.title}`;
          const dotGrid = strip.querySelector('.cas-dot-grid');
          prod.variants.forEach((v, vi) => {
            const dot = document.createElement('button');
            dot.className = 'cas-dot';
            dot.setAttribute('aria-label', v.scent || v.title);
            dot.setAttribute('role', 'radio');
            dot.setAttribute('aria-checked', 'false');
            dot.setAttribute('tabindex', vi === 0 ? '0' : '-1');
            dot.style.setProperty('--c', v.hex || '#c8b89a');
            dot.addEventListener('click', async e => {
              e.stopPropagation();
              if(busy) return;
              busy = true;
              dotGrid.querySelectorAll('.cas-dot').forEach(d=>{ d.classList.remove('sel'); d.setAttribute('aria-checked','false'); });
              dot.classList.add('sel'); dot.setAttribute('aria-checked','true');
              try {
                const freshCart = await window.cascadiaState.refresh();
                await swapReward(freshCart, tier.type, v.id, {});
                setTimeout(() => { strip.style.display='none'; }, 350);
                dispatchUpdate();
              } catch(err){ console.warn('[cascadia studio] scent add failed', err); }
              finally { busy = false; }
            });
            dotGrid.appendChild(dot);
          });
          strip.style.display = 'block';
        } else if(prod.variants.length === 1){
  busy = true;
  (async () => {
    try {
      const freshCart = await window.cascadiaState.refresh();
      await swapReward(freshCart, tier.type, prod.variants[0].id, {});
      dispatchUpdate();
    } catch(err){ console.warn('[cascadia studio] product add failed', err); }
    finally { busy = false; }
  })();
} else if(prod.variants.length > 1){
  // multiple variants, no scents — show variant image picker
  strip.querySelector('.cas-scent-strip-label').textContent = 'Choose a sample';
  const dotGrid = strip.querySelector('.cas-dot-grid');
  dotGrid.style.cssText = 'display:flex;flex-wrap:wrap;gap:8px;padding:4px 0;';
  prod.variants.forEach((v, vi) => {
    const card = document.createElement('button');
    card.style.cssText = [
      'all:unset',
      'cursor:pointer',
      'display:flex',
      'flex-direction:column',
      'align-items:center',
      'gap:4px',
      'width:64px',
      'padding:6px',
      'border-radius:10px',
      'border:0.5px solid #e8e5e0',
      'background:#fff',
      'text-align:center',
      'transition:border-color .15s'
    ].join(';');
    card.innerHTML = `
      <img src="${prod.image}" alt="${v.title}"
        style="width:48px;height:48px;object-fit:cover;border-radius:6px;display:block;" />
      <span style="font-family:'Jost',sans-serif;font-size:9.5px;color:#6b5c4a;line-height:1.3;">${v.title}</span>
    `;
    card.addEventListener('mouseenter', () => { card.style.borderColor = '#3d2314'; });
    card.addEventListener('mouseleave', () => { if(!card.classList.contains('sel')) card.style.borderColor = '#e8e5e0'; });
    card.addEventListener('click', async e => {
      e.stopPropagation();
      if(busy) return;
      busy = true;
      dotGrid.querySelectorAll('button').forEach(c => {
        c.classList.remove('sel');
        c.style.borderColor = '#e8e5e0';
      });
      card.classList.add('sel');
      card.style.borderColor = '#03593A';
      try {
        const freshCart = await window.cascadiaState.refresh();
        await swapReward(freshCart, tier.type, v.id, {});
        setTimeout(() => { strip.style.display = 'none'; }, 350);
        dispatchUpdate();
      } catch(err){ console.warn('[cascadia studio] variant add failed', err); }
      finally { busy = false; }
    });
    dotGrid.appendChild(card);
  });
  strip.style.display = 'block';
}
      });
    });
  }

  if(!document.querySelector('#cascadia-studio-css')){
    const st = document.createElement('style');
    st.id = 'cascadia-studio-css';
    st.textContent = `
      #cascadia-studio{background:#faf8f5;border:0.5px solid #e8e5e0;border-radius:12px;margin:12px 0;overflow:visible;font-family:'Jost',sans-serif;flex-shrink:0;width:100%;}

      /* header */
      .cas-studio-header{padding:11px 16px 8px;border-bottom:0.5px solid #e8e5e0;display:flex;align-items:center;justify-content:space-between;}
      .cas-studio-kicker{font-size:8px;letter-spacing:.16em;text-transform:uppercase;color:#c8a24e;margin:0 0 1px;font-weight:400;font-family:'Jost',sans-serif;}
      .cas-studio-title{font-family:'Cormorant Garamond',Georgia,serif;font-size:18px;font-style:italic;font-weight:400;color:#3d2314;margin:0;line-height:1.1;}
      .cas-studio-badge{font-size:11px;color:#03593A;font-weight:500;background:#f0f7f0;border:0.5px solid #c8e0c8;border-radius:999px;padding:3px 11px;white-space:nowrap;flex-shrink:0;}

      /* tier rows */
      .cas-tier-row{border-left:2px solid #f0ece7;padding:6px 16px;border-bottom:0.5px solid #e8e5e0;}
      .cas-tier-row:last-child{border-bottom:none;}
      .cas-tier-row.cas-unlocked{border-left-color:#c8a24e;background:#fff;padding:8px 16px 10px;}
      .cas-tier-row.cas-next{border-left-color:#e0c97a;background:#fffdf7;padding:7px 16px;}

      /* tier head */
      .cas-tier-head{display:flex;align-items:center;justify-content:space-between;margin-bottom:4px;}
      .cas-tier-name{font-size:11px;font-weight:500;color:#3d2314;}
      .cas-tier-name--muted{color:#6b5c4a;font-weight:400;}
      .cas-tier-name--faint{color:#c8c0b8;font-weight:400;}

      /* tier status */
      .cas-tier-status--unlocked{font-size:11px;color:#03593A;letter-spacing:.04em;}
      .cas-tier-status--faint{font-size:10px;color:#d4cdc5;}

      /* next tier meta */
      .cas-tier-next-meta{display:flex;flex-direction:column;align-items:flex-end;gap:2px;}
      .cas-tier-progress-bar{width:52px;height:3px;border-radius:999px;background:#e8e5e0;overflow:hidden;}
      .cas-tier-progress-fill{height:100%;background:linear-gradient(90deg,#c8a24e,#e0c97a);border-radius:999px;transition:width .4s ease;}
      .cas-tier-almost{font-size:11px;color: #8e641cff;letter-spacing:.03em;}
      .cas-tier-away{font-size:11px;font-style:italic;font-family:'Cormorant Garamond',Georgia,serif;color:#c8a24e;margin:2px 0 6px;}

      /* dots */
      .cas-dot-grid{display:flex;flex-wrap:wrap;gap:6px;margin-bottom:8px;}
      .cas-scent-pill-grid{display:flex;flex-wrap:wrap;gap:6px;}
      .cas-scent-pill{display:inline-flex;align-items:center;gap:6px;border:1px solid #e8e5e0;background:#fff;border-radius:999px;padding:5px 10px 5px 6px;cursor:pointer;transition:.15s;}
      .cas-scent-pill:hover{border-color:#c8b89a;}
      .cas-scent-pill.sel{border-color:#3d2314;border-width:1.5px;background:#faf6ef;}
      .cas-scent-pill:focus-visible{outline:2px solid #03593A;outline-offset:2px;}
      .cas-scent-pill-dot{width:16px;height:16px;border-radius:50%;flex-shrink:0;box-shadow:inset 0 0 0 2px #fff, 0 0 0 0.5px rgba(0,0,0,.1);}
      .cas-scent-pill-name{font-family:'Jost',sans-serif;font-size:11px;color:#3d2314;white-space:nowrap;}
      .cas-dot{width:22px;height:22px;border-radius:50%;border:0;cursor:pointer;padding:0;position:relative;background:var(--c,#c8b89a);box-shadow:0 0 0 0.5px rgba(0,0,0,.1),inset 0 0 0 1.5px rgba(255,255,255,.8);transition:.15s;flex-shrink:0;}
      .cas-dot:hover{transform:scale(1.1);}
      .cas-dot.sel{box-shadow:0 0 0 2px #3d2314,inset 0 0 0 1.5px rgba(255,255,255,.8);}
      .cas-dot.sel::before{content:'✓';position:absolute;inset:0;display:flex;align-items:center;justify-content:center;color:#fff;font-size:10px;text-shadow:0 1px 2px rgba(0,0,0,.4);}
      .cas-dot:focus-visible{outline:2px solid #03593A;outline-offset:2px;}

      /* selname */
      .cas-selname{font-size:11px;font-style:italic;font-family:'Cormorant Garamond',Georgia,serif;color:#6b5c4a;margin:0;}
      .cas-selname b{font-weight:600;font-style:normal;color:#3d2314;}
      .cas-selname--dim{color:#a59a8a;}

      /* product tier */
      .cas-prod-row{display:flex;gap:8px;margin-bottom:8px;overflow-x:auto;padding-bottom:2px;scrollbar-width:none;}
      .cas-prod-row::-webkit-scrollbar{display:none;}
      .cas-prod-card{flex-shrink:0;width:72px;border:1px solid #e8e5e0;border-radius:8px;padding:7px;text-align:center;cursor:pointer;transition:.15s;}
      .cas-prod-card.sel{border-color:#03593A;background:#f0f7f0;}
      .cas-prod-img{width:32px;height:32px;border-radius:6px;object-fit:cover;margin:0 auto 5px;display:block;}
      .cas-prod-img-empty{background:#e8f0e8;}
      .cas-prod-name{font-size:11px;color:#3d2314;line-height:1.25;margin:0;}
      .cas-scent-strip{background:#f0f7f0;border:1px solid #c8e0c8;border-radius:8px;padding:8px 10px;margin-bottom:8px;}
      .cas-scent-strip-label{font-size:11px;color:#03593A;font-weight:500;letter-spacing:.04em;text-transform:uppercase;margin:0 0 6px;}
      .cas-scent-strip .cas-dot-grid{margin-bottom:0;}
    `;
    document.head.appendChild(st);
  }

  let scheduled = false;
  function scheduleRender(){
    if(scheduled) return;
    scheduled = true;
    setTimeout(() => { scheduled = false; render(); }, 150);
  }

  document.addEventListener('ajaxProduct:added', scheduleRender);
  document.addEventListener('cart:updated', scheduleRender);
  document.addEventListener('cart:refresh', scheduleRender);
  document.addEventListener('cascadia:cart-changed', scheduleRender);
  document.addEventListener('click', e => {
    if(e.target.closest('[data-cart-drawer-toggle], a[href="/cart"], .cart-icon, [class*="cart-icon"], [class*="header__icon--cart"]')){
      scheduleRender();
    }
  });

  render();
  console.log('[cascadia studio] live · tiers', TIERS.length);
})();